module.exports = __webpack_public_path__ + "static/media/lock-purple.23e4a85a.svg";